import Vue from 'vue';
import { getBoIdMapping } from '../../helpers/boIdMapping';
import { InstanceType } from '../../enums/InstanceType';
import { LocationDTO } from '../../model/LocationDTO';
import { omit } from 'lodash-es';

export async function apartmentOverviewData(context: Vue) {
	let location: LocationDTO;

	try {
		location = await context.$locationService.fetchLocationByCatalogNumber(context.$route.params.locationCatalogNumber)
	} catch (error) {
		if (error.response.status == 404) {
			redirectToHomepage(context);
		}
	}

	// check if location is allowed in the preview (for showing preparation time version)
	if (context.$route.query.predbezne && context.$route.query.csh) {
		if (location.id.toString() !== context.$route.query.predbezne) {
			redirectToHomepage(context);
		}
		if (context.$store.publicatingTimeId >= context.$store.timeId) {	// if the time version to be previewed has already been published
			context.$router.replace({ query: omit(context.$route.query, ['csh', 'predbezne']) }); // omit preview parameters
		}
	}

	return {
		location,
		boIdMapping: getBoIdMapping(InstanceType.ApartmentLocation, location)
	};
}

function redirectToHomepage(context: Vue) {
	context.$router.push('/'); // redirect to homepage
	throw new Error();
}
